import React, {useState} from 'react'
import { TextField, Button, MenuItem, Grid, Paper, InputAdornment } from '@material-ui/core'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import AddIcon from '@material-ui/icons/Add'
import ServicesList from './ServicesList'
import moment from 'moment'
import convertTime from '../../js/convertTime'
import { addService } from '../../store/actions/customerAccountingActions'
import arrSort from 'array-sort'
import {dialog} from '../../store/actions/dialogActions'

const AddService= ({selectMembers, activeApp, config, taskType, tasks, services, user }) => {

    const [selectedTask, setSelectedTask ] = useState('')
    const [selectedToMemberId, setSelectedToMemberId ] = useState('')

    const handleTaskSelect = value => {
        return setSelectedTask(value)
    }
    const handleToMemberSelect = value => {
        return setSelectedToMemberId(value)
    }
    const handleAddService = e => {
        e.preventDefault()
        if(taskType==='manually') {
            const { date, amount, count, task } = e.target
        
            if(task.value.length<3)
                return alert('Sie müssen eine Leistung eingeben!')
            const service = {
                serviceType: 'manuelly',
                date: date.value,
                amount: Number(amount.value),
                count: Number(count.value),
                task: task.value
            }
            return addService(service)
        }
        const { date, hours, km } = e.target
        const _task = tasks.filter(t=>t.id===e.target.taskId.value)
        const convertedHours = convertTime(hours.value)
        const member = selectMembers[activeApp][config.accountingRecipientType].find(member=>member.id===selectedToMemberId)
        const service = {
            serviceType: 'select',
            date: date.value,
            hours: Number(convertedHours.toFixed(2)),
            hoursTxt: hours.value,
            km: Number(km.value),
            toMember: member,
            task: _task[0]
        }
        setSelectedTask('')

       return addService(service)
    }
    const handleDeleteTask = (index) => {
   
        const delService = () => {
            const _services = [...services]
            _services.splice(index, 1)
            return delService(index)
        }

        return dialog({
            isOpen: true,
            title: 'Leistung löschen?',
            text: `Wollen Sie die Leistung ${services[index].task} löschen?`,
            buttons: [
                {title: 'Löschen', onClick: delService, variant: 'contained', color: 'secondary'},
                {title: 'Abbrechen', onClick: ()=>dialog('reset'), variant: 'contained', color: 'primary'}
            ]
        })
   
    }
    const addBtnDisabled = Boolean(selectedTask.length===0) || Boolean(selectedToMemberId.length===0)
    const addServiceOptions = {
        selectedTask,
        selectedToMemberId,
        handleTaskSelect,
        addBtnDisabled,
        handleToMemberSelect,
        handleAddService,
        selectMembers,
        config,
        tasks,
        activeApp
    }
    return (
        <div>
    <div style={{height: '13.5rem', overflowY: 'scroll', overflowX:'hidden'}}>
        <ServicesList services={services} deleteTask={handleDeleteTask} taskType={taskType} />
    </div>
        <Paper style={{backgroundColor: 'white', marginTop: '1rem', paddingRight: '0.5rem'}}>
                {taskType==='auto'
                    ? <AddServiceDefault {...addServiceOptions} />
                    : <AddServiceManuel 
                        handleAddService={handleAddService}
                        addBtnDisabled={false}
                    />
                }
        </Paper>
    </div>
  )
}

export default compose(
    firestoreConnect(() => [  
     //  { collection: 'accounting', doc: 'pflegekasse', subcollections: [{ collection: 'services' }], storeAs: 'servicesPflegekasse' },
     { collection: 'tasks', where: [['type', '==', 'nachbarschaftshilfe']], storeAs: 'accountingTasks' }
 
 ]), // or { collection: 'todos' }
 connect((state) => {
    const { accountingTasks } = state.firestore.ordered
    return ({
        user: state.user,
        activeApp: state.user.settings.activeApp,
        config: state.customerAccounting.config,
        taskType: state.customerAccounting.config.taskType,
        tasks: accountingTasks && accountingTasks,
        selectMembers : {
            nachbarschaftshilfe: {
                requester: state.firestore.ordered._members && state.firestore.ordered._members.filter(member=>member.roles.requester),
                provider: state.firestore.ordered._members && state.firestore.ordered._members.filter(member=>member.roles.provider)
            },
            pflegekasse : {
                requester: state.firestore.ordered.members && state.firestore.ordered.members.filter(member=>member.pflegekasse).filter(member=>member.pflegeRoles.requester),
                provider: state.firestore.ordered.members && state.firestore.ordered.members.filter(member=>member.pflegekasse).filter(member=>member.pflegeRoles.provider)
            }
        },
        services: state.customerAccounting.services
    })}),
 )(AddService)

 const AddServiceManuel = ({handleAddService, addBtnDisabled}) => {
    return (
        <form onSubmit={handleAddService} >
            <Grid container spacing={2}>
                <Grid item md={1} sx={12} ></Grid>
                <Grid item md={2} sx={12} >
                    <TextField
                        defaultValue={moment().format('YYYY-MM-DD')} 
                        name='date'
                        fullWidth
                        id='service-add-date-input'
                        label='Datum'
                        type='date'
                        size='small'
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item md={2} sx={12} >
                    <TextField
                        defaultValue={1}
                        name='amount'
                        fullWidth
                        id='service-add-amount'
                        label='Euro'
                        type='number'
                        size='small'
                        inputProps={{
                            min: 1,
                            step: 0.01,
                        }}
                        InputProps={{
                            endAdornment: <InputAdornment position="start">€</InputAdornment>,
                          }}
                    />
                </Grid>
                <Grid item md={1} sx={12} >
                    <TextField
                        defaultValue={1}
                        name='count'
                        fullWidth
                        id='service-add-count'
                        label='Anz.'
                        inputProps={{
                            min: 1,
                            step: 1,
                        }}
                        type='number'
                        size='small'
                    />
                </Grid>
                <Grid item md={5} sx={12} >
                    <TextField 
                        name='task'
                        id='service-add-leistung-input'
                        label='Leistung eingeben'
                        size='small'
                        fullWidth
                    />
                </Grid>
                <Grid item md={1} sx={12} >
                    <Button
                        disabled={addBtnDisabled} 
                        type='submit'
                        size='small'
                        variant='contained'
                        style={{marginTop: '0.6rem'}}
                    >
                        <AddIcon />
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
 }

 const AddServiceDefault = ({
    selectedTask,
    setSelectedTask,
    selectedToMemberId,
    setSelectedToMemberId,
    handleTaskSelect,
    addBtnDisabled,
    handleToMemberSelect,
    handleAddService,
    selectMembers,
    config,
    tasks,
    activeApp
    }) => {
     return (
        <form onSubmit={handleAddService} >
        <Grid container spacing={2}>
            <Grid item md={1} sx={12} ></Grid>
            <Grid item md={2} sx={12} >
                <TextField
                    defaultValue={moment().format('YYYY-MM-DD')} 
                    name='date'
                    fullWidth
                    id='service-add-date-input'
                    label='Datum'
                    type='date'
                    size='small'
                    InputLabelProps={{shrink: true}}
                />
            </Grid>
            <Grid item md={2} sx={12} >
                <TextField 
                    name='tomember'
                    fullWidth
                    id='service-add-tomember-select'
                    size='small'
                    select
                    value={selectedToMemberId}
                    onChange={e=>handleToMemberSelect(e.target.value)}
                    label='Empfänger'
                    children={
                        selectMembers[activeApp][config.accountingRecipientType]
                            ? arrSort(selectMembers.nachbarschaftshilfe[config.accountingRecipientType], 'userName').map(member=><MenuItem key={member.id} dense value={member.id}>{`${member.userName} MG-Nr:${member.memberId}`}</MenuItem>)
                            : [] 
                    } 
                />
            </Grid>
            
            <Grid item md={2} sx={12} >
                <TextField
                    defaultValue={'01:00'}
                    type='time'
                    //inputProps={{step:300}} 
                    name='hours'
                    fullWidth 
                    id='service-add-time-input'
                    label='Stunden'
                    styles={{textAlign: 'right'}}
                    size='small'
                    InputLabelProps={{shrink: true}}
                />
            </Grid>
            <Grid item md={1} sx={12} >
                <TextField
                    defaultValue={0}
                    name='km'
                    fullWidth
                    id='service-add-count'
                    label='KM'
                    type='number'
                    size='small'
                />
            </Grid>
            <Grid item md={3} sx={12}>
                <TextField 
                    name='taskId'
                    fullWidth
                    id='service-add-leistungs-select'
                    size='small'
                    select
                    value={selectedTask}
                    onChange={e=>handleTaskSelect(e.target.value)}
                    label='Leistung auswählen'
                    children={tasks ? tasks.map(task=><MenuItem key={task.id} dense value={task.id}>{task.name}</MenuItem>) : [] }
                />
            </Grid>
            <Grid item md={1} sx={12} >
                <Button
                    disabled={addBtnDisabled} 
                    type='submit'
                    size='small'
                    variant='contained'
                    style={{marginTop: '0.6rem'}}
                >
                    <AddIcon />
                </Button>
            </Grid>
        </Grid>
    </form>
     )
 }